var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { push, } from 'react-router-redux';
import Card from 'antd/lib/card';
import 'antd/lib/card/style/index.css';
import PageBasic from '../templates/PageBasic';
import Authentication from '../components/Authentication';
var typoStyles = require('src/imports/styles/styles.typography.scss');
var selfStyles = require('./styles.scss');
var crimpIcon = require('src/assets/logo/crimp-icon@0,25x.png');
var PageAuthentication = (function (_super) {
    __extends(PageAuthentication, _super);
    function PageAuthentication(props) {
        var _this = _super.call(this, props) || this;
        _this.navigateToNext = _this.navigateToNext.bind(_this);
        return _this;
    }
    PageAuthentication.prototype.navigateToNext = function () {
        this.props.actions.handleNavigate(this.props.redirectPath);
    };
    PageAuthentication.prototype.render = function () {
        return (React.createElement(PageBasic, { documentTitle: 'Login' },
            React.createElement("div", { className: selfStyles.wrapper },
                React.createElement(Card, { className: selfStyles.card, hoverable: false },
                    React.createElement("div", { className: selfStyles.brand },
                        React.createElement("img", { src: crimpIcon }),
                        process.env.NODE_ENV === 'development' && React.createElement("strong", null, "development"),
                        React.createElement("h1", { className: typoStyles.crimp }, process.env.REACT_APP_DEPLOY_ENV === 'staging' ? 'PINCH' : 'CRIMP'),
                        React.createElement("h2", null, "Organizer Platform")),
                    React.createElement(Authentication, { navigateToNext: this.navigateToNext })))));
    };
    PageAuthentication.defaultProps = {
        redirectPath: '/welcome',
    };
    return PageAuthentication;
}(React.Component));
var mapDispatchToProps = function (dispatch) { return ({
    actions: bindActionCreators({
        handleNavigate: push,
    }, dispatch),
}); };
export default connect(undefined, mapDispatchToProps)(PageAuthentication);



//////////////////
// WEBPACK FOOTER
// ./src/pages/PageAuthentication/index.tsx
// module id = 329
// module chunks = 0